import type { ListIdentities } from '@cloudFunctions/types/payments/listIdentities';
import type { BackendRouteDefinition } from '../types';

/**
 * Migrated to `api-core-node` in PRA-776 (Phase 5 Sub-phase 1). The
 * cloudFunctions callable was retired in S9-WB2 (PRA-804); the type-only
 * `ListIdentities` namespace at the import path above remains the
 * canonical wire contract.
 */
export const listIdentitiesRoute = {
  transport: 'api',
  method: 'POST',
  path: '/admin/finix/identities:lookup',
  body: (requestData: ListIdentities.RequestData) => requestData,
} as const satisfies BackendRouteDefinition;
